import { Metadata, MetadataExt, MetadataOption, MetadataValidatorIdentifier } from "src/app/common/models/metadati/metadata";
import { FormFieldBase } from "../../dynamic-form-field/components/dynamic-form-light/models/form-field-base";


export function getFormFieldBase(metadata: MetadataExt):FormFieldBase{

    let out = {
        key: metadata.identifier,
        label: metadata.name,
        required: metadata.validators && metadata.validators.filter(val => val.id === MetadataValidatorIdentifier.REQUIRED).length > 0,
        controlType: getControlType(metadata),
        placeholder: metadata.suggestion,
        type: metadata.type.name,
        value:getValue(metadata),
        options:getOptions(metadata),
        size:getSize(metadata)
    }

    //console.log("FormFieldBase per identificativo : " + metadata.identifier + " :: " + JSON.stringify(out))
    return out;
}

function getControlType(metadata: MetadataExt) {
    switch (metadata.type.id) {
        case 'TEXT_SHORT':
            return "text";
        case 'TEXT_LONG':
            return "textbox";
        case 'NUMBER':
            return "number";
        case 'CURRENCY':
            return "currency";
        case 'URL':
            return "textbox";
        case 'DATE':
            return "date";
        case 'LIST_CHECKBOX':
            return "checkbox";
        case 'LIST_RADIOBUTTON':
            return "radio";
        case 'LIST_SINGLE_SELECTION':
            return "dropdown";
        case 'LIST_MULTIPLE_SELECTION':
            return "multi";
        case 'BINARY_CURSOR':
            return "switch";
        case 'LABEL':
            return "chips";
        default:
            break;
    }
}

function getOptions(metadata: MetadataExt){
    let out = [];
    if(metadata.options && metadata.options.length > 0){
        metadata.options.forEach(opt => {
            out.push(getOption(opt));
        });
    }
    return out;
}

function getOption(opt: MetadataOption){
    return {
        value: opt.value,
        label: opt.name ,
        descrizione: opt.description,
        id: opt.id,
      }
}

function getValue(metadata: MetadataExt){

    let out : any;
    if(metadata.value){
        if(metadata.type.id === 'LIST_MULTIPLE_SELECTION' || metadata.type.id === 'LIST_CHECKBOX' || metadata.type.id === 'LABEL'){
            const listValues = metadata.value.split(',');
            out = listValues;

        } else {
            try {
                out = JSON.parse(metadata.value);
            } catch (error) {
                out = metadata.value;
            }
        }
    } else {
        out = defaultValue(metadata);
    }
    return out;
}


export function defaultValue(metadata: MetadataExt) {
    switch (metadata.type.id) {
        case 'TEXT_SHORT':
            return "";
        case 'TEXT_LONG':
            return "";
        case 'NUMBER':
            break;
        case 'CURRENCY':
            break;
        case 'URL':
            return "";
        case 'DATE':
            return "";
        case 'LIST_CHECKBOX':
            break;
        case 'LIST_RADIOBUTTON':
            break;
        case 'LIST_SINGLE_SELECTION':
            break;
        case 'LIST_MULTIPLE_SELECTION':
            break;
        case 'BINARY_CURSOR':
            return "false";
        case 'LABEL':
            break;
        default:
            break;
    }
}


function getSize(metadata: MetadataExt) {
    switch (metadata.type.id) {
        case 'TEXT_SHORT':
            return '6';
        case 'TEXT_LONG':
            return '12';
        case 'NUMBER':
            return '6';
        case 'CURRENCY':
            return '6';
        case 'URL':
            return '6';
        case 'DATE':
            return '6';
        case 'LIST_CHECKBOX':
            return '6';
        case 'LIST_RADIOBUTTON':
            return '6';
        case 'LIST_SINGLE_SELECTION':
            return '6';
        case 'LIST_MULTIPLE_SELECTION':
            return '6';
        case 'BINARY_CURSOR':
            return '6';
        case 'LABEL':
            return '6';
        default:
            break;
    }
}

export function mockValue(metadata: MetadataExt[]){
    metadata.forEach(element => {
        element.value= getMockValue(element)
    });
    return metadata;
}

function getMockValue(metadata: MetadataExt) {
    switch (metadata.type.id) {
        case 'TEXT_SHORT':
            return "TESTO CORTO";
        case 'TEXT_LONG':
            return "TESTO LUNGO";
        case 'NUMBER':
            return "1234567890";
        case 'CURRENCY':
            return "12000.5";
        case 'URL':
            break;
        case 'DATE':
            return "1699484400000";
        case 'LIST_CHECKBOX':
            const opt0 = metadata.options[0];
            const opt1 = metadata.options[1];
            let out = []
            out.push(opt0.id)
            out.push(opt1.id)
            return JSON.stringify(out);
        case 'LIST_RADIOBUTTON':
            return metadata.options[0].id;
        case 'LIST_SINGLE_SELECTION':
            return metadata.options[0].id;
        case 'LIST_MULTIPLE_SELECTION':
            const opt00 = metadata.options[0];
            const opt11 = metadata.options[1];
            let outmulti = []
            outmulti.push(opt00.id)
            outmulti.push(opt11.id)
            return JSON.stringify(outmulti);
        case 'BINARY_CURSOR':
            return "true";
        case 'LABEL':
            break;
        default:
            break;
    }
}
